<template>
  <div class="free-shipping">
    <span v-if="leftToFreeShippingAmount > 0">
      {{ leftToFreeShippingCurrencyFormatted }}
    </span>
    {{ leftToFreeShippingText }}
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    totalRaw: Number
  },
  setup(props) {
    // TODO - Move this to store when shopping-cart store is done.
    let leftToFreeShippingData = window.leftToFreeShippingData;

    const leftToFreeShippingAmount = computed(() => {
      if (!leftToFreeShippingData) {
        return;
      }
      
      let amount = Math.floor(leftToFreeShippingData.limit - props.totalRaw);
      if (amount <= 0) {
        amount = 0;
      }
      
      return amount;
    });

    const leftToFreeShippingCurrencyFormatted = computed(() => {
      return window.VendreCurrencyFormatter(leftToFreeShippingAmount.value);
    });

    const leftToFreeShippingText = computed(() => {
      if (!leftToFreeShippingData) {
        return;
      };

      let text = leftToFreeShippingData.textLimitNotReached;
      if (leftToFreeShippingAmount.value == 0) {
        text = leftToFreeShippingData.textLimitReached;
      }
      return text;
    });
    
    return {
      leftToFreeShippingAmount,
      leftToFreeShippingCurrencyFormatted,
      leftToFreeShippingText
    }
  }
}
</script>

<style scoped lang="scss">

.free-shipping {
  text-align: right;
}
</style>